import { columnsDefault, columnsFull } from './columnLists'

const STORAGE_KEY = 'table'
const COLUMNS = 'columns'

function getTableKey () {
  return STORAGE_KEY + '_' + COLUMNS
}

function getTableColumnsKey (tableKey) {
  return getTableKey() + '_' + tableKey
}

export function getTables () {
  if (window.localStorage) {
    return JSON.parse(window.localStorage.getItem(getTableKey())) || []
  }
  return []
}

export function getTableColumnsData (tableKey) {
  let selectedColumns = null
  if (window.localStorage) {
    selectedColumns = JSON.parse(window.localStorage.getItem(getTableColumnsKey(tableKey))) || null
  }
  if (!selectedColumns && columnsDefault[tableKey]) {
    selectedColumns = columnsDefault[tableKey]
  }
  return selectedColumns
}
export function getTableFullColumnsData () {
  return (columnsFull || [])
}
export function getKeysFromDefaultColumns () {
  return Object.keys(columnsDefault)
}

export function setTableColumnsData (tableKey, columns) {
  if (window.localStorage) {
    let tables = getTables()
    if (columns !== null) {
      if (!tables.includes(tableKey)) {
        tables.push(tableKey)
      }
      window.localStorage.setItem(getTableColumnsKey(tableKey), JSON.stringify(columns))
    } else {
      tables = tables.filter(t => t !== tableKey)
      window.localStorage.removeItem(getTableColumnsKey(tableKey))
    }
    window.localStorage.setItem(getTableKey(), JSON.stringify(tables))
  }
}

export function removeTableColumnsData (tableKey) {
  setTableColumnsData(tableKey, null)
}



// WEBPACK FOOTER //
// ./src/utils/columns.js